import React from 'react';

import {Table} from 'react-bootstrap';

import NotificationsTypes from '../../../../data/NotificationsTypes';

const MasteCronTable = (props) => {
    const {notifications} = props;

    const rows = notifications.map(notification => {
        return (
            <tr key={notification.id}>
                <td>{notification.id}</td>
                <td>{notification.messageID}</td>
                <td>{NotificationsTypes[notification.type]}</td>
                <td>{notification.segments}</td>
                <td>{notification.sendTime}</td>
                <td>{notification.days}</td>
                <td>{notification.timezone}</td>


            </tr>
        )
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Message ID</th>
                    <th>Type</th>
                    <th>Segments</th>
                    <th>Send Time</th>
                    <th>Days</th>
                    <th>TimeZone</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default MasteCronTable;


// WEBPACK FOOTER //
// ./src/scenes/MasterCron/components/MasterCronTable/index.js